import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import mapValues from 'lodash/mapValues'
import isEqual from 'lodash/isEqual'

import { FormattedMessage } from 'react-intl'
import { Text, Form, FormField, Incrementor } from 'src/Components'
import {
  IconBathtub,
  IconShower,
  IconSink,
  IconToilet
} from 'src/Components/shared/Icon'
import NavigationButtons from '../Buttons/NavigationButtons'

import { selectHomeBaths } from 'src/store/selectors/home/answers'

import styles from './HomeFactsSteps.module.scss'

const BathIcons = [IconBathtub, IconShower, IconSink, IconToilet]

const EnterBaths = ({ onBaths, onBack, defaultBaths }) => {
  const bathsCount = useSelector(selectHomeBaths)

  const handleSubmit = (e, updatedBaths) => {
    e.preventDefault()
    const isDirty = !isEqual(mapValues(updatedBaths, parseInt), bathsCount)

    onBaths(updatedBaths, isDirty)
  }

  const fullBathRef = useRef(null)
  const halfBathRef = useRef(null)
  const threeQuarterBathRef = useRef(null)
  const quarterBathRef = useRef(null)
  const defaultFullBaths = Math.floor(defaultBaths || 0)

  return (
    <Form
      name='homeFactsBaths'
      className={styles.homeFactsStep}
      onSubmit={handleSubmit}
      fields={['full', 'threeQuarters', 'half', 'quarter']}
    >
      <Text className={styles.homeFactsHeader} size='xl'>
        <FormattedMessage
          id='TYV.panels.baths.head'
          defaultMessage='How many bathrooms?'
        />
      </Text>
      <div>
        <div>
          <FormField
            className={styles.homeFactsBathField}
            ref={fullBathRef}
            input={Incrementor}
            name='full'
            min={0}
            max={99}
            value={bathsCount.full || defaultFullBaths}
            required
          >
            <FormattedMessage
              id='TYV.panels.baths.full'
              defaultMessage='Full baths'
            />
          </FormField>
          <div className={styles.homeFactsBathIcons}>
            {BathIcons.map((BathIcon, i) => {
              return (
                <BathIcon
                  key={i}
                  className={styles.homeFactsBathIcon}
                  color='heather'
                />
              )
            })}
          </div>
        </div>
        <div>
          <FormField
            className={styles.homeFactsBathField}
            ref={threeQuarterBathRef}
            input={Incrementor}
            name='threeQuarters'
            min={0}
            max={99}
            value={bathsCount.threeQuarters}
            required
          >
            <FormattedMessage
              id='TYV.panels.baths.threeQuarters'
              defaultMessage='3/4 baths'
            />
          </FormField>
          <div className={styles.homeFactsBathIcons}>
            <IconToilet className={styles.homeFactsBathIcon} />
            <IconSink className={styles.homeFactsBathIcon} />
            <IconShower className={styles.homeFactsBathIcon} />
          </div>
        </div>
        <div>
          <FormField
            className={styles.homeFactsBathField}
            ref={halfBathRef}
            input={Incrementor}
            name='half'
            min={0}
            max={99}
            value={bathsCount.half}
            required
          >
            <FormattedMessage
              id='TYV.panels.baths.half'
              defaultMessage='Half baths'
            />
          </FormField>
          <div className={styles.homeFactsBathIcons}>
            <IconToilet className={styles.homeFactsBathIcon} />
            <IconSink className={styles.homeFactsBathIcon} />
          </div>
        </div>
        <div>
          <FormField
            className={styles.homeFactsBathField}
            ref={quarterBathRef}
            input={Incrementor}
            name='quarter'
            min={0}
            max={99}
            value={bathsCount.quarter}
            required
          >
            <FormattedMessage
              id='TYV.panels.baths.quarter'
              defaultMessage='1/4 baths'
            />
          </FormField>
          <div className={styles.homeFactsBathIcons}>
            <IconToilet className={styles.homeFactsBathIcon} />
          </div>
        </div>
      </div>
      <NavigationButtons handleBack={() => onBack(25)} />
    </Form>
  )
}

export default EnterBaths
